export const validateNumericInput = (value) => {
  const numericRegex = /^[0-9]*$/;
  return numericRegex.test(value);
};
